<template>
  <div v-show="packingConversionCount(item)">
    ({{ packingConversionCount(item) }}<dict :dict-group="'measurementUnit'" :dict-key="item.measurementUnit" v-show="showLeftCount(item)"/>)
  </div>
</template>
<script>

export default {
  name: 'orderGoodsPackageCount',
  props: {
    item: {
      type: Object,
      require: true
    },
    count:{
      type: Number,
      require: true
    }
  },
  computed: {},
  methods: {
    packingConversionCount(item) {
      if (!item||!this.count) {
        return "";
      }
      let orderAmount = this.count;
      let ratio = item.packingConversionRatio;
      let ratioUnit = item.packingConversionRatioUnit;
      if (!orderAmount || !ratio || !ratioUnit) {
        return "";
      }
      // 求余
      let count = Math.floor(orderAmount / ratio);
      let left = orderAmount % ratio;
      if (isNaN(count) && isNaN(left)) {
        return "";
      }
      if (count === 0 && left !== 0) {
        return left+' ';
      }
      if (count !== 0 && left === 0) {
        return count + ' ' + ratioUnit;
      }
      if (count !== 0 && left !== 0) {
        return count + ' ' + ratioUnit + ' ' + left+' ';
      }
    },
    showLeftCount(item) {
      if (!item||!this.count) {
        return "";
      }
      let orderAmount = this.count;
      let ratio = item.packingConversionRatio;
      if (!orderAmount || !ratio) {
        return "";
      }
      let left = orderAmount % ratio;
      if (isNaN(left) || left === 0) {
        return "";
      }
      return left;
    }
  }
}
</script>
